module.exports = __webpack_public_path__ + "img/angular.7d4cf273.svg";